import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {translateToEnglish} from '../../../shared/helpers/string.utils';

@Component({
  selector: 'app-blog-quick-view',
  templateUrl: './blog-quick-view.component.html',
  styleUrls: ['./blog-quick-view.component.scss']
})
export class BlogQuickViewComponent implements OnInit {
  @Input() blog!: BlogQuickView;
  @Input() empty!: boolean;
  @Input() showEllipsis: boolean = false;
  baseUrl = environment.baseUrl;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  goToBlog(id: number, title: string) {
    this.router.navigate([`/blog-new/${translateToEnglish(title.replace(/ - /g, '-').replace(/ /g, '-'))}/${id}`]);
  }

}

export interface BlogQuickView {
  author: string;
  categoryId: number;
  id: number;
  img: string;
  isPublish: boolean
  shortDescription: string
  subCategoryId: number
  tags: [{ id: number, tagName: string }]
  title: string
}
